import { createFileRoute } from "@tanstack/react-router"

import { LogbookPage } from "@/trips/components/mileage/logbook-page"

export const Route = createFileRoute("/_app-shell/logbook")({
  head: () => ({ meta: [{ title: "Logbook - Kestly" }] }),
  component: LogbookPage,
})
